import React from "react";
import { Outlet } from "react-router-dom";
import GoLiveNav from "./components/GoLiveNav";
import "./styles/tailwind.css";
import "./styles/golive.css";

// Previously broke out of the routed-page padding with negative margins
// (`-mt-6 -mx-8 w-[calc(100%+64px)]`) so the old *fixed*-position GoLiveNav
// could span edge-to-edge underneath it. Now that GoLiveNav renders in-flow
// (see components/GoLiveNav.jsx), GoLive just needs to sit inside the
// normal .orion-content-inner padding like every other page — no bleed hack
// needed, and one less thing to keep in sync with the shell's dimensions.
export default function GoLiveLayout() {
  return (
    <div className="gl-layout flex flex-col min-h-full">
      <GoLiveNav />
      <Outlet />
    </div>
  );
}
